import addCalendarEventsToCache from './addCalendarEventsToCache';
import filterCacheableCalendarEvents from '../../utils/filterCacheableCalendarEvents';
import { CalendarEvent, CalendarEventKey } from 'mini-calendar-event-types';

/**
 * Insert calendar events into events cache and emit eventsAdded signal
 * @param folderId Calendar folder id
 * @param calendarEvents The list of calendar events to be inserted in events cache
 */
export default function addCalendarEventsAndNotify(
    calendarEvents: CalendarEvent[]
): CalendarEventKey[] {
    // We only insert the calendar events that belong to selected calendar and those that
    // overlap with the date range that is loaded in the cache.
    // We ignore the rest as those would be loaded from server by the cache when needed.
    const validEventsToAdd = filterCacheableCalendarEvents(calendarEvents);
    const calEventKeys = addCalendarEventsToCache(validEventsToAdd);
    return calEventKeys;
}
